import { CardDetails } from '@app-pages/models/card-details';
import { PageState } from '@app-core/models/_enums';

export class AppState {
  constructor(
    public currentPageState?: PageState,
    public modifiedDate?: Date
  ) {}
  cardDetails: CardDetails;
  version: string;
}
